import * as act from 'app/actions';

export const GET_COURSES = 'validation/GET_COURSES';
export const getCourses = (payload) => act.action(GET_COURSES, { payload });

export const APPLY_PLAN = 'validation/APPLY_PLAN';
export const applyPlan = (payload) => act.action(APPLY_PLAN, { payload });
